import { gql } from '@apollo/client';

export const GET_CURRENCY_TYPES = gql`
  query GET_CURRENCY_TYPES {
    getCurrencyTypes
  }
`;
